import DownloadControls from 'components/video/edit/Form/DownloadControls';
import css from './ClipDownload.module.scss';

type ClipDownloadProps = {
    assetId: number;
    provider: string;
    beginTimeToEndTime: string;
    clipData: {
        isReady: boolean;
        url?: string | undefined;
        error?: string;
    };
    progress?: number | undefined;
};

export function formatSecondsToHHMMSS(totalSeconds: number): string {
    const totalWholeSeconds = Math.floor(totalSeconds);

    const hours = Math.floor(totalWholeSeconds / 3600);
    const minutes = Math.floor((totalWholeSeconds % 3600) / 60);
    const seconds = totalWholeSeconds % 60;

    const pad = (num: number): string => num.toString().padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function ClipDownload({
    assetId,
    provider,
    beginTimeToEndTime,
    clipData: { isReady, url, error },
    progress,
}: ClipDownloadProps) {
    const [begin, end] = beginTimeToEndTime.split(':');

    let content: React.ReactNode;

    if (isReady) {
        content = (
            <span className={css.thirdColumn}>
                <DownloadControls id={assetId} provider={provider} urlLink={url} buttonOnly />
            </span>
        );
    } else if (error) {
        content = <span className={css.warning}>Clip download unavailable</span>;
    } else {
        content = <span className={css.thirdColumn}>{`PREPARING CLIP DOWNLOAD ${progress ?? 0}%`}</span>;
    }

    return (
        <div className={css.history}>
            <div className={css.row}>
                <span className={css.item}>{formatSecondsToHHMMSS(Number(begin))}</span>
                <span className={css.item}>{formatSecondsToHHMMSS(Number(end))}</span>
                {content}
            </div>
        </div>
    );
}
